<span
    class="ds-loading-dots"
    role="status"
    [ngClass]="['ds-loading-dots--' + size, 'ds-loading-dots--' + theme]"
    [style.color]="color"
    [attr.aria-label]="ariaLabel"
>
    <span class="ds-loading-dots__dot"></span>
    <span class="ds-loading-dots__dot"></span>
    <span class="ds-loading-dots__dot"></span>
</span>
